import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  emptyBasketHeadline: {
    id: 'BasketEmpty.Headline',
    defaultMessage: 'Dein Warenkorb ist leer',
  },
  loggedInInfoText: {
    id: 'BasketEmpty.LoggedIn.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  loggedOutInfoText: {
    id: 'BasketEmpty.LoggedOut.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  emptyBasketButton: {
    id: 'BasketEmpty.GoToShop',
    defaultMessage: 'Weiter im Shop',
  },
  loginBasketButton: {
    id: 'BasketEmpty.Login',
    defaultMessage: 'Anmelden',
  },
});
export const BasketEmpty: React.FC<{ loggedIn?: boolean }> = ({ loggedIn }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="max-w-[49.625rem]" data-testid="basket-empty-wrapper">
      <div className="mb-6 flex flex-col items-center justify-between text-center">
        <div className="icon-emp-cart size-[5rem]" />
        <div className="text-size-h4 md:text-size-h3 mt-2.5 mb-1 md:mb-1.5">
          {formatMessage(messages.emptyBasketHeadline)}
        </div>
        <div className="text-size-body-base mb-3.5 md:mb-6">
          {loggedIn && formatMessage(messages.loggedInInfoText)}
          {!loggedIn && formatMessage(messages.loggedOutInfoText)}
        </div>
      </div>
    </div>
  );
};
